<template>
  <div class="page-home container">
    <el-button
      type="success"
      icon="el-icon-plus"
      class="mb-3 mt-5"
      @click="dialogVisible = true"
    >
      افزودن
    </el-button>
    <data-table
      ref="table"
      class="mt-3"
      title="لیست آلارم ها"
      uid="table-alarms"
      :query="query"
      :options="options"
      :before-update="beforeUpdate"
    >
      <el-table-column
        prop="devieId"
        label="کد دستگاه "
        align="center"
        min-width="80"
      >
        <p slot-scope="{ row }" class="text-primary">
          {{ row.deviceId }}
        </p>
      </el-table-column>
      <el-table-column
        prop="data"
        label="متن آلارم"
        align="center"
        min-width="150"
      >
        <p slot-scope="{ row }" class="gray-500">
          {{ row.data }}
        </p>
      </el-table-column>
      <el-table-column
        prop="entity"
        label="رطوبت"
        align="center"
        min-width="90"
      >
        <p slot-scope="{ row }" style="direction:ltr">
          {{ row.entity.humidity + '  %' }}
        </p>
      </el-table-column>
      <el-table-column prop="entity" label="دما" align="center" min-width="۹0">
        <template slot-scope="{ row }">
          <p
            v-if="row.entity.temperature !== '-222.00'"
            style="direction:ltr; "
          >
            {{ row.entity.temperature + '  ˚C' }}
          </p>
          <p v-else class="text-grey">.....</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="alarmAt"
        label="زمان آلارم"
        align="center"
        min-width="100"
      >
        <date-time-display slot-scope="{ row }" :date="row.alarmAt" />
      </el-table-column>
    </data-table>
  </div>
</template>

<script>
import ListQuery from '@/graphql/alarm/Alarms.gql'
import DateTimeDisplay from '@/components/DateTimeDisplay'
export default {
  name: 'AlarmsList',
  components: {
    DateTimeDisplay
  },
  data() {
    return {
      loading: false,
      query: ListQuery
    }
  },
  computed: {
    options() {
      let filters = [
        {
          type: 'date',
          field: 'alarmAt',
          attr: {
            placeholder: 'زمان آلارم'
          }
        }
      ]
      return {
        filters,
        columns: []
      }
    }
  },
  methods: {
    update() {
      this.$refs.table.update()
    },
    beforeUpdate(variables, done) {
      delete variables.filter.sort
      done(variables)
    }
  }
}
</script>
<style scoped lang="scss">
.gray-500 {
  color: #9a9a9a;
}
.danger-light {
  color: #ff001da3;
}
</style>
